import gql from 'graphql-tag';

export const AdminCreatePostMutation = gql`
  mutation AdminCreatePost(
    $title: String!
    $subtitle: String!
    $type: postTypeEnum
    $content: String!
    $published: Boolean!
    $link: String
    $publishedBy: String
    $featuredImageUrl: String
    $publishedAt: Date
  ) {
    createPost(
      title: $title
      subtitle: $subtitle
      type: $type
      content: $content
      published: $published
      link: $link
      publishedBy: $publishedBy
      featuredImageUrl: $featuredImageUrl
      publishedAt: $publishedAt
    ) {
      id
    }
  }
`;

export default AdminCreatePostMutation;
